"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var SelectMultiple_1 = require("./SelectMultiple");
var NativeSelect_1 = require("./NativeSelect");
var SimulateSelect_1 = require("./SimulateSelect");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.Select = (0, forward_ref_with_statics_1.forwardRefWithStatics)(function (props, ref) {
    // eslint-disable-next-line react/destructuring-assignment
    if (props.type === 'simulate') {
        return react_1.default.createElement(SimulateSelect_1.SimulateSelect, (0, tslib_1.__assign)({ ref: ref }, props, { type: "simulate" }));
    }
    return react_1.default.createElement(NativeSelect_1.NativeSelect, (0, tslib_1.__assign)({ ref: ref }, props, { type: "native" }));
}, {
    Multiple: SelectMultiple_1.SelectMultiple,
    defaultLabelAlign: 'middle',
});
exports.Select.displayName = 'Select';
